import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ICollapsibleNavItemProps } from '@amobee/component-library';
import { ObjectType } from 'src/app/data/constants/object-type.enum';
import { AutoCompleteMappedItem } from 'src/app/common/components/auto-complete/auto-complete.component';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { applySearchAndPagination } from 'src/app/misc/util/util';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  collapsibleItems: ICollapsibleNavItemProps[] = [];
  currentObjectType: string;
  objectTypeEnum: any = ObjectType;
  customerId: number;
  customerName: string;
  advertiserId: number;
  brandId: number;
  brandName: string;
  brandList: AutoCompleteMappedItem[] = [];
  reloadTableTriggered: any;
  isMultiAdvertiser: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private campaignAdapter: CampaignAdapter
  ) { }

  ngOnInit() {
    this.currentObjectType = this.route.snapshot.data.objectType;
    this.collapsibleItems = [
      {
        icon: 'ProductCampaigns',
        label: 'Campaigns',
        title: 'Campaigns',
        active: this.currentObjectType == ObjectType.Campaign,
        linkProps: {
          onClick: () => {
            this.router.navigate([ObjectType.Campaign, 'list']);
          }
        }
      },
      // {
      //   icon: 'Deal',
      //   label: 'Deals',
      //   title: 'Deals',
      //   active: this.currentObjectType == ObjectType.Deal,
      //   linkProps: {
      //     onClick: () => {
      //       this.router.navigate([ObjectType.Deal, 'marketplace']);
      //     }
      //   }
      // },
      {
        icon: 'Creatives',
        label: 'Creatives',
        title: 'Creatives',
        active: this.currentObjectType == ObjectType.Creative,
        linkProps: {
          onClick: () => {
            this.router.navigate([ObjectType.Creative, 'list']);
          }
        }
      },
    ];
    if (this.route.snapshot.data.cbaId) {
      this.customerId = this.route.snapshot.data.cbaId.customerId;
      this.advertiserId = this.route.snapshot.data.cbaId.advertiserId;
      this.brandId = this.route.snapshot.data.cbaId.brandId;
      this.campaignAdapter.isMultiAdvertiser().then(isMultiAdvertiser => {
        this.isMultiAdvertiser = isMultiAdvertiser;
        if (isMultiAdvertiser) {
          this.campaignAdapter.getBrandIds(this.customerId, this.advertiserId).then((value: any[]) => {
            if (value) {
              this.brandList = value.map(v => {
                if (v.Id === this.brandId) {
                  this.brandName = v.Name;
                }
                return {
                  label: v.Name,
                  value: v.Id
                }
              });
            }
          });
        } else {
          this.campaignAdapter.getCustomers().then((value: any[]) => {
            if (value) {
              let customer = value.find((v => v.Id === this.customerId));
              if (customer) {
                this.customerName = customer.Name;
              }
            }
          });
        }
      });
    }
  }

  autoCompletetConfig = {
    brandAutoCompletePromise: (params: any) => {
      return Promise.resolve(applySearchAndPagination(this.brandList, params));
    },
    handleOnBrandSelect: (item: AutoCompleteMappedItem) => {
      this.campaignAdapter.updateCBAId(this.customerId, this.advertiserId, Number(item.value));
      this.brandId = Number(item.value);
      this.brandName = item.label;
      this.reloadTableTriggered = {};
    },
    responseMapper: (response: any, offset: number, limit: number) => {
      return {
        results: response,
        hasMore: response.length >= limit
      }
    }
  };

}
